import '../../styles/DashboardMainContent.css';
import Card from '../ui/Card';

const DashboardMainContent = ({
  activeTab,
  courses = [],
  purchasedCourses = [],
  isLoading = false,
  onCourseClick
}) => {
  const renderHomeContent = () => {
    if (isLoading) {
      return (
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading courses...</p>
        </div>
      );
    }

    if (courses.length === 0) {
      return (
        <div className="no-courses">
          <p>No courses available at the moment.</p>
        </div>
      );
    }

    return (
      <div className="courses-grid">
        {courses.map((course) => (
          <Card
            key={course.id}
            title={course.title}
            description={course.description}
            price={course.price}
            originalPrice={course.originalPrice}
            duration={course.duration}
            image={course.image}
            alt={`${course.title} course thumbnail`}
            onCardClick={() => onCourseClick(course.id)}
            className="course-card"
          />
        ))}
      </div>
    );
  };



  const renderCategoriesContent = () => (
    <div className="categories-section">
      <h2 className="h2 text-primary">Categories</h2>
      <p className="body2 text-secondary">Categories content coming soon...</p>
    </div>
  );

  const renderCoursesContent = () => {
    if (isLoading) {
      return (
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading your courses...</p>
        </div>
      );
    }

    if (purchasedCourses.length === 0) {
      return (
        <div className="my-courses-section">
          <h2 className="h2 text-primary">My Courses</h2>
          <p className="body2 text-secondary">You haven't purchased any courses or topics yet.</p>
        </div>
      );
    }

    // Group purchased items by course
    const coursesWithAccess = {};
    
    purchasedCourses.forEach(item => {
      const courseId = item.courseId || item.id;
      if (!coursesWithAccess[courseId]) {
        coursesWithAccess[courseId] = {
          ...item,
          purchasedTopics: [],
          isFullCourse: item.isFullCourse || false
        };
      }
      
      // If it's a topic, add it to the course's purchased topics
      if (item.topicId && !item.isFullCourse) {
        if (!coursesWithAccess[courseId].purchasedTopics) {
          coursesWithAccess[courseId].purchasedTopics = [];
        }
        coursesWithAccess[courseId].purchasedTopics.push({
          id: item.topicId,
          title: item.topicTitle || `Topic ${item.topicId}`
        });
      }
    });

    return (
      <div className="my-courses-section">
        <h2 className="h2 text-primary">My Courses</h2>
        {Object.values(coursesWithAccess).map(course => (
          <div key={course.id} className="course-card">
            <h3>{course.title}</h3>
            {course.isFullCourse ? (
              <p>Full course access</p>
            ) : (
              <div>
                <p>Purchased Topics:</p>
                <ul>
                  {course.purchasedTopics?.map(topic => (
                    <li key={topic.id}>
                      {topic.title}
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <button 
              className="btn btn-primary"
              onClick={() => onCourseClick(course.id)}
            >
              View Course
            </button>
          </div>
        ))}
      </div>
    );
  };

  const renderAllCoursesContent = () => {
    if (isLoading) {
      return (
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading all courses...</p>
        </div>
      );
    }

    if (courses.length === 0) {
      return (
        <div className="no-courses">
          <p>No courses available at the moment.</p>
        </div>
      );
    }

    return (
      <div className="courses-grid">
        {courses.map((course) => (
          <Card
            key={course.id}
            title={course.title}
            description={course.description}
            price={course.price}
            originalPrice={course.originalPrice}
            duration={course.duration}
            image={course.image}
            alt={`${course.title} course thumbnail`}
            onCardClick={() => onCourseClick(course.id)}
            className="course-card"
          />
        ))}
      </div>
    );
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'home':
        return renderHomeContent();
      case 'all-courses':
        return renderAllCoursesContent();
      case 'categories':
        return renderCategoriesContent();
      case 'courses':
        return renderCoursesContent();
      default:
        return renderHomeContent();
    }
  };

  return (
    <div className="dashboard-main-content">
      <div className="content-container">
        {renderContent()}
      </div>
    </div>
  );
};

export default DashboardMainContent;
